import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [{
  path: '/',
  component: resolve => require(['../components/page/index.vue'], resolve)
},
{
  path: '/index',
  name: 'index',
  component: resolve => require(['../components/page/index.vue'], resolve)
},
{
  path: '/login',
  name: 'login',
  meta: {
    title: '数据赋能'
  },
  component: resolve => require(['../components/page/login.vue'], resolve)
},
{
  path: '/home',
  name: 'home',
  meta: {
    title: '数据赋能'
  },
  component: resolve => require(['../components/page/home.vue'], resolve)
},
// {
//   path: '/qykb',
//   name: 'qykb',
//   meta: {
//     title: '企业口碑'
//   },
//   component: resolve => require(['../components/page/qykb.vue'], resolve)
// },
{
  path: '/ppcy',
  name: 'ppcy',
  meta: {
    title: '品牌词云'
  },
  component: resolve => require(['../components/page/ppcy.vue'], resolve)
},
{
  path: '/ztfx',
  name: 'ztfx',
  meta: {
    title: '问题剖析'
  },
  component: resolve => require(['../components/page/ztfx.vue'], resolve)
},
{
  path: '/cpph',
  name: 'cpph',
  meta: {
    title: '差评排行'
  },
  component: resolve => require(['../components/page/cpph.vue'], resolve)
},
{
  path: '/fzzl',
  name: 'fzzl',
  meta: {
    title: '分值总览'
  },
  component: resolve => require(['../components/page/fzzl.vue'], resolve)
},
{
  path: '/xjzl',
  name: 'xjzl',
  meta: {
    title: '星级总览'
  },
  component: resolve => require(['../components/page/xjzl.vue'], resolve)
},
{
  path: '/cpfx',
  name: 'cpfx',
  meta: {
    title: '菜品剖析'
  },
  component: resolve => require(['../components/page/cpfx.vue'], resolve)
},
{
  path: '/dwpx',
  name: 'dwpx',
  meta: {
    title: '多维剖析'
  },
  component: resolve => require(['../components/page/dwpx.vue'], resolve)
},
{
  path: '/report',
  name: 'report',
  meta: {
    title: '消费者洞察月报'
  },
  component: resolve => require(['../components/page/report.vue'], resolve)
},
{
  path: '/plmx',
  name: 'plmx',
  meta: {
    title: '评论明细'
  },
  component: resolve => require(['../components/page/plmx.vue'], resolve)
},
{
  path: '/topic',
  name: 'topic',
  meta: {
    title: '疫情专题'
  },
  component: resolve => require(['../components/page/Topic.vue'], resolve)
},
{
  path: '/qykb',
  name: 'qykb',
  meta: {
    title: '品牌总览'
  },
  component: resolve => require(['../components/page/Main.vue'], resolve)
}
]

const router = new Router({
  mode: 'history',
  routes: routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js